<template>
  <div class="scene-view">
    <div
      id="engineContainer"
      class="engine-container"
      ref="engineContainer"
      :style="`visibility:${canvasVisible ? 'visible' : 'hidden'}`" />
    <EngineLoading
      v-if="isLoadingVisible"
      :percentage="percentage" />
  </div>
</template>

<script>
import EngineLoading from '@/components/Loading.vue'
import { Store } from '@/utils/store'
import eventBus from '@/utils/eventBus'
import { isTemplateVersionConsistentWithEngine } from '@/utils/generalMethods'

// 需要设置坐标系和基点的数据类型
const SETCRS_DATA_TYPE = [0, 11, 15]

const elemDataType = [17, 18, 19]

export default {
  data() {
    return {
      percentage: 0, // 进度条数值
      isLoadingVisible: true, // 是否显示进度条
      canvasVisible: false,

      // 分批加载的数据集
      batchedDataSets: [],
      isStartLoadDataSet: false,

      loadedElems: []
    }
  },
  computed: {
    viewModeType() {
      return this.$route.query.viewMode
    }
  },
  components: {
    EngineLoading
  },
  mounted() {
    this.addEventListener()
    eventBus.$on('unLoadModel', data => {
      window.BlackHole3D.Model.unloadAllDataSet()
      this.canvasVisible = false
      this.percentage = 0
      this.isLoadingVisible = true
      this.isStartLoadDataSet = false
      this.batchedDataSets = []
    })

    eventBus.$on('changeCanvasWidth', () => {
      this.setCanvasSize()
    })

    if (this.isEngineCanvasExist()) {
      this.copyCanvas()
      if (this.isEnginePreLoaded()) {
        this.$nextTick(() => {
          this.setSceneViewMode()

          this.$eventManage.fire('engineCreated', {})
        })
      }
    } else {
      this.createEngineCanvas()
      this.initEngine()
    }
  },
  beforeDestroy() {
    this.unloadAllMainSce()
    this.removeEventListener()
    this.isLoadingVisible = false

    window.removeEventListener('beforeunload', this.onBeforeUnload)
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    addEventListener() {
      document.addEventListener('REDataSetLoadProgress', this.onProgress)
      document.addEventListener('RESystemEngineCreated', this.onCreated)
      document.addEventListener('REDataSetLoadFinish', this.onFinish)
      document.addEventListener('REAddEntityFinish', this.onEntityFinish)
      document.addEventListener('REExitEntityEditMode', this.onExitEntityEdit)
      document.addEventListener('RESystemSelElement', this.onSelElement)
      document.addEventListener('RESystemSelShpElement', this.onSelShpElement)
      document.addEventListener('RESystemUIEvent', this.onUIClick)
      // prettier-ignore
      document.addEventListener("REEditControlPosMatchFinish", this.onREEditControlPosMatchFinish);

      document.addEventListener('mousedown', this.onMouseDown)

      window.addEventListener('beforeunload', this.onBeforeUnload)
      window.addEventListener('resize', this.onResize)
    },
    removeEventListener() {
      document.removeEventListener('RESystemEngineCreated', this.onCreated)
      document.removeEventListener('REDataSetLoadProgress', this.onProgress)
      document.removeEventListener('REDataSetLoadFinish', this.onFinish)
      document.removeEventListener('REAddEntityFinish', this.onEntityFinish)
      // prettier-ignore
      document.removeEventListener("REExitEntityEditMode", this.onExitEntityEdit);
      document.removeEventListener('RESystemSelElement', this.onSelElement)
      // prettier-ignore
      document.removeEventListener("RESystemSelShpElement", this.onSelShpElement);
      document.removeEventListener('RESystemUIEvent', this.onUIClick)
      // prettier-ignore
      document.removeEventListener("REEditControlPosMatchFinish", this.onREEditControlPosMatchFinish);

      document.removeEventListener('mousedown', this.onMouseDown)

      let domRef = null
      if (window.BlackHole3D) {
        domRef = window.BlackHole3D.canvas
      } else {
        domRef = document.getElementById('engineCanvas')
      }
      domRef.removeEventListener('mousemove', this.onCanvasMouseMove)
    },
    initEngine() {
      window.BlackHole3D = window.BlackHole3D ? window.BlackHole3D : {}
      window.BlackHole3D.canvas = document.getElementById('engineCanvas')

      if (typeof window.BlackHole3D.RealBIMWeb === 'undefined') {
        window.BlackHole3D = window.CreateBlackHoleWebSDK(window.BlackHole3D)
      }
    },
    onCreated() {
      const timer = setInterval(() => {
        if (this.isEnginePreLoaded()) {
          clearInterval(timer)
          this.setCanvasSize()

          this.setSceneViewMode()
          this.$eventManage.fire('engineCreated', {})

          let domRef = null
          if (window.BlackHole3D) {
            domRef = window.BlackHole3D.canvas
          } else {
            domRef = document.getElementById('engineCanvas')
          }
          domRef.addEventListener('mousemove', this.onCanvasMouseMove)
        }
      }, 500)
    },
    onProgress(e) {
      if (!this.isStartLoadDataSet) return

      let percentage = e.detail.progress

      if (percentage < 10) {
        this.fromZeroFlag = true
      }
      if (percentage === 12 && this.fromZeroFlag) {
        percentage = 10
      }

      this.percentage = percentage
    },
    onFinish() {
      const BlackHole3D = window.BlackHole3D
      BlackHole3D.Graphics.setSysUIPanelVisible(false)

      if (!this.isStartLoadDataSet) return

      this.canvasVisible = true
      this.isLoadingVisible = false

      if (this.batchedDataSets.length) {
        const dataSets = this.batchedDataSets.pop()
        this.loadDataSets(dataSets, false)
      } else {
        // 解决场景中存在二维图纸，矢量数据时，相机定位不准的问题
        BlackHole3D.Camera.setCamBelowTerrain(true)
        // prettier-ignore
        this.$eventManage.fire("dataSetLoadFinish", {loadedElems: this.loadedElems,});

        if (window.isGridClipEnable) {
          BlackHole3D.Grid.setClipEnable(true)
        }

        // 解决模型加载完成后，键盘WASD不能控制引擎相机移动的问题
        // prettier-ignore
        setTimeout(() => {BlackHole3D.canvas.focus(); }, 500);
      }
    },
    incrementalLoadDataSets(dataSets, count) {
      const BlackHole3D = window.BlackHole3D
      BlackHole3D.Graphics.setSysUIPanelVisible(false)

      const wmtsData = dataSets.filter(el => el.dataSetType === 10)
      const notWmtsData = dataSets.filter(el => el.dataSetType !== 10)
      dataSets = [...notWmtsData, ...wmtsData]

      for (let i = 0; i < dataSets.length; i += count) {
        const batchedDataSets = dataSets.slice(i, i + count)
        this.batchedDataSets.push(batchedDataSets)
      }

      const firstDataSets = this.batchedDataSets.pop()
      // 对于第一批加载的数据集, isClearLoaded需要设置为true, 否则会导致REDataSetLoadFinish事件不会触发
      this.loadDataSets(firstDataSets, true)
    },
    async loadDataSets(dataSets, isClearLoaded) {
      this.isStartLoadDataSet = true

      const isVersionConsist = await isTemplateVersionConsistentWithEngine()
      const BlackHole3D = window.BlackHole3D
      if (!isVersionConsist) {
        const dataSetList = [
          {
            dataSetId: 'res_skybox',
            resourcesAddress: window.skyBoxUrl
          }
        ]
        BlackHole3D.Model.loadDataSet(dataSetList)

        BlackHole3D.Common.setMaxResMemMB(2000)
        BlackHole3D.Common.setExpectMaxInstMemMB(1900)
        BlackHole3D.Common.setExpectMaxInstDrawFaceNum(10000000)
        BlackHole3D.Common.setPageLoadLev(2)
        this.$message.error('请升级SDK版本至3.2.0.3247之后的版本')
        return
      }

      let dataSetList = []
      if (!dataSets.length) {
        let obj = {
          dataSetId: 'res_skybox',
          resourcesAddress: window.skyBoxUrl
        }
        dataSetList.push(obj)
      } else {
        dataSets.forEach(item => {
          let obj = {
            dataSetId: item.resId,
            resourcesAddress: this.getResourcesAddress(item),
            dataSetCRS: this.getDataSetCRS(item),
            engineOrigin: this.getEngineOrigin(item),
            dataSetCRSNorth: this.getDataSetCRSNorth(item),
            useTransInfo: true,
            transInfo: this.getTransInfo(item),
            dataSetSGContent: item.context ? item.context : ''
          }
          if (item.dataSetType === 21 || item.dataSetType === 22) {
            obj.groundDisplay = item.isTouchDown
            obj.terrSuffix = item.isTouchDown ? '' : item.resId
          }

          let find = this.loadedElems.find(
            el => el.dataSetId === item.dataSetId
          )
          if (elemDataType.includes(item.dataSetType) && !find) {
            this.loadedElems.push(item)
          }

          dataSetList.push(obj)
        })
      }
      BlackHole3D.Model.loadDataSet(dataSetList, isClearLoaded)

      BlackHole3D.Common.setMaxResMemMB(2000)
      BlackHole3D.Common.setExpectMaxInstMemMB(1900)
      BlackHole3D.Common.setExpectMaxInstDrawFaceNum(10000000)
      BlackHole3D.Common.setPageLoadLev(2)
    },
    onCanvasMouseMove(event) {
      const BlackHole3D = window.BlackHole3D
      let isEdit = BlackHole3D.Entity.getEditMode()
      if (!isEdit) return
      let coorInfo = {
        clientX: event.clientX,
        clientY: event.clientY
      }
      this.$eventManage.fire('canvasMouseMove', { coorInfo })
    },
    onMouseDown(e) {
      // 按下鼠标中键时，禁用滚动
      if (e.button === 1) {
        e.preventDefault()
      }
      // 如果处于构件编辑状态，按下右键退出构件编辑
      if (e.button === 2) {
        let isEntityEdit = window.BlackHole3D.Entity.getEditMode()
        if (isEntityEdit) {
          this.$eventManage.fire('exitEntityEdit', {})
        }
      }
    },
    onBeforeUnload() {
      window.BlackHole3D.releaseEngine()
    },
    onResize() {
      this.setCanvasSize()
    },
    onEntityFinish() {
      this.$eventManage.fire('entityFinish', {})
    },
    onExitEntityEdit() {
      this.$eventManage.fire('exitEntityEdit', {})
    },
    onSelElement() {
      this.setSelElemsBlendAttr()

      let probeInfo = window.BlackHole3D.Probe.getCurCombProbeRet()
      let elemInfo = {
        dataSetId: probeInfo.dataSetId,
        elemId: probeInfo.elemId,
        elemType: probeInfo.elemType
      }
      this.$eventManage.fire('selElement', { elemInfo })
    },
    onSelShpElement() {
      const BlackHole3D = window.BlackHole3D
      let probeInfo = BlackHole3D.Probe.getCurCombProbeRet()
      let shpElemId = probeInfo.elemId
      let elemType = probeInfo.elemType
      if (elemType !== 'ShapeElem') return

      let dataSetId = ''
      if (shpElemId && typeof shpElemId === 'string') {
        dataSetId = shpElemId && shpElemId.split('_')[1]
      }

      let shpElemInfo = {
        dataSetId: dataSetId,
        elemId: probeInfo.elemId,
        elemType: probeInfo.elemType
      }
      this.$eventManage.fire('selShpElement', { shpElemInfo })

      const Coordinate = BlackHole3D.Coordinate
      let ancName = probeInfo.elemId

      let ancInfo = BlackHole3D.Anchor.getAnc(ancName)
      if (!ancInfo) return
      let screenPos = Coordinate.getWorldPosToScreenPos(ancInfo.pos)
      let clickScrPos = probeInfo.elemScrPos

      // 防止点击Gizmo坐标轴时触发相关响应
      if (!ancName.includes('Btn')) return

      if (ancName === 'singleBtn') {
        this.$eventManage.fire('startEdit', {})
        return
      }
      let deltaX = clickScrPos[0] - screenPos[0]
      if (deltaX < -15) {
        this.$eventManage.fire('startEdit', {})
      } else {
        this.$eventManage.fire('openAnimDialog', {
          visible: true,
          posInfo: clickScrPos
        })
      }
    },
    onUIClick(eventInfo) {
      let detail = eventInfo.detail
      let btnName = detail.btnname
      let btnState = detail.btnstate
      if (btnName.includes('Measure')) {
        window.BlackHole3D.BIM.delAllSelElems()
        window.BlackHole3D.Anchor.delAllAnc()
      }

      if (btnName.includes('UIClr_Style')) {
        this.$eventManage.fire('themeChange', { themeName: btnName })
      }

      if (btnName.includes('Catalog_Tree')) {
        if (btnState == 0) {
          window.BlackHole3D.Graphics.setBtnActiveState(btnName, 1)
        } else {
          window.BlackHole3D.Graphics.setBtnActiveState(btnName, 0)
        }
        this.$eventManage.fire('customBtnClick', { btnName })
      }

      if (btnName.includes('Attribute')) {
        if (btnState == 0) {
          window.BlackHole3D.Graphics.setBtnActiveState(btnName, 1)
        } else {
          window.BlackHole3D.Graphics.setBtnActiveState(btnName, 0)
        }
        this.$eventManage.fire('customBtnClick', { btnName })
      }

      if (btnName.includes('Explode')) {
        if (btnState == 0) {
          window.BlackHole3D.Graphics.setBtnActiveState(btnName, 1)
        } else {
          window.BlackHole3D.Graphics.setBtnActiveState(btnName, 0)
        }
        this.$eventManage.fire('customBtnClick', { btnName })
      }

      if (btnName.includes('Close_SysUI')) {
        this.$eventManage.fire('customBtnClick', { btnName })
      }

      if (btnName.includes('PosMatch_Reset_Btn')) {
        this.$eventManage.fire('resetPosition', {})
      }
      if (btnName.includes('PosMatch_Exit_Btn')) {
        this.$eventManage.fire('exitPositionEdit', {})
      }
      if (btnName.includes('PosMatch_Save_Btn')) {
        this.$eventManage.fire('savePosition', {})
      }
    },
    onREEditControlPosMatchFinish(eventInfo) {
      let eventDetail = eventInfo.detail
      if (eventDetail.errorType === 1) {
        // prettier-ignore
        this.$message.error("控制点数量不够，匹配失败，请选取足够的控制点后再匹配");
        return
      }

      if (eventDetail.errorType === 2) {
        // prettier-ignore
        this.$message.error("未指定数据集，匹配失败，请选择需要配准的数据集");
        return
      }
    },
    setEngineWorldCRS(worldCRS) {
      window.BlackHole3D.Coordinate.setEngineWorldCRS(worldCRS)
    },
    setViewAngle(camLoc) {
      let forceCamLoc = new window.BlackHole3D.REForceCamLoc()
      forceCamLoc.force = true
      forceCamLoc.camPos = camLoc.camPos
      forceCamLoc.camRotate = camLoc.camRotate
      window.BlackHole3D.Camera.setCamForcedInitLoc(forceCamLoc)
    },
    clearCamForcedLoc() {
      let forceCamLoc = new window.BlackHole3D.REForceCamLoc()
      forceCamLoc.force = false
      forceCamLoc.camPos = [0, 0, 0]
      forceCamLoc.camRotate = [0, 0, 0, 0]
      window.BlackHole3D.Camera.setCamForcedInitLoc(forceCamLoc)
    },
    setSelElemsBlendAttr() {
      const BlackHole3D = window.BlackHole3D
      let blendAttr = BlackHole3D.BIM.getSelElemsBlendAttr()
      blendAttr.elemClr = new BlackHole3D.REColor(255, 0, 0, 200)
      blendAttr.clrWeight = 128
      blendAttr.alphaWeight = 200
      BlackHole3D.BIM.setSelElemsBlendAttr(blendAttr)
    },
    unloadAllMainSce() {
      window.BlackHole3D.Extrude.delData([])
      window.BlackHole3D.Water.delData([])
      // 卸载所有数据会导致挖洞纹理丢失，并且进入场景编辑和预览的时候会添加纹理，
      // 而引擎中纹理大小有限制，因此离开前需要删除所有纹理
      window.BlackHole3D.Extrude.delAllExtrudeFaceTex()
      Store.extrudeTextureList = []

      window.BlackHole3D.Entity.delEntities('', '', [])
      window.BlackHole3D.Model.unloadAllDataSet()
    },
    setSceneViewMode() {
      let viewMode = this.$route.query.viewMode
      if (viewMode === 'Sphere') {
        window.BlackHole3D.Common.setFakeSphMode(true)
      } else {
        window.BlackHole3D.Common.setFakeSphMode(false)
      }
    },
    setCanvasSize() {
      const domRef = this.$refs.engineContainer
      if (domRef) {
        window.BlackHole3D.m_re_em_window_width = domRef.clientWidth
        window.BlackHole3D.m_re_em_window_height = domRef.clientHeight
      }
    },
    unloadDataSets(dataSetIds) {
      dataSetIds.forEach(item => {
        window.BlackHole3D.Model.unloadDataSet(item)
      })

      let allDataSetIds = window.BlackHole3D.Model.getAllDataSetId()
      if (!allDataSetIds.length) {
        // 卸载所有数据会导致挖洞纹理丢失，因此清空全局纹理列表
        Store.extrudeTextureList = []

        let dataSetList = []
        let obj = {
          dataSetId: 'res_skybox',
          resourcesAddress: window.skyBoxUrl
        }
        dataSetList.push(obj)
        window.BlackHole3D.Model.loadDataSet(dataSetList)
      }
    },
    unloadEntity(entityInfo) {
      let { dataSetId, entityType, elemIdList } = entityInfo
      window.BlackHole3D.Entity.delEntities(dataSetId, entityType, elemIdList)
    },
    showDataSets(dataSets) {
      const elemDataSetType = [17, 18, 19]

      dataSets.forEach(item => {
        let { dataSetId, dataSetType } = item
        if (elemDataSetType.includes(dataSetType)) {
          let elemId = item.elemId
          this.showElement(dataSetId, [elemId])
        } else {
          if (dataSetType !== 0) {
            let terrId = window.BlackHole3D.Terrain.getDataSetTerrId(dataSetId)
            if (terrId) {
              this.showCadAndVector(dataSetId)
            } else {
              window.BlackHole3D.Grid.setValidState(dataSetId, true)
            }
          } else {
            window.BlackHole3D.BIM.resetElemAttr(dataSetId, [])
          }
        }
      })
    },
    hideDataSets(dataSets) {
      const elemDataSetType = [17, 18, 19]

      dataSets.forEach(item => {
        let { dataSetId, dataSetType } = item
        if (elemDataSetType.includes(dataSetType)) {
          let elemId = item.elemId
          this.hiddenElement(dataSetId, [elemId])
        } else {
          if (dataSetType !== 0) {
            let terrId = window.BlackHole3D.Terrain.getDataSetTerrId(dataSetId)
            if (terrId) {
              this.hideCadAndVector(dataSetId)
            } else {
              window.BlackHole3D.Grid.setValidState(dataSetId, false)
            }
          } else {
            window.BlackHole3D.BIM.setElemAlpha(dataSetId, [], 0)
          }
        }
      })
    },
    highLightDataSets(dataSets, isFocus) {
      if (isFocus) {
        this.focusDataSets(dataSets)
      }

      const BlackHole3D = window.BlackHole3D
      BlackHole3D.BIM.delAllSelElems()

      let color = new BlackHole3D.REColor(254, 64, 7, 180)
      dataSets.forEach(item => {
        BlackHole3D.BIM.addToSelDataSet(item.dataSetId)
      })
      BlackHole3D.BIM.setSelElemsAttr(color, 1, true)
    },
    highLightEntities(entities, isFocus) {
      if (isFocus) {
        this.focusEntities(entities, true)
        return
      }

      const BlackHole3D = window.BlackHole3D
      BlackHole3D.BIM.delAllSelElems()

      let color = new BlackHole3D.REColor(254, 64, 7, 180)
      entities.forEach(item => {
        BlackHole3D.BIM.addToSelElems(item.dataSetId, item.elemIds)
      })
      BlackHole3D.BIM.setSelElemsAttr(color, 1, true)
    },
    focusDataSets(dataSets, isClearSel) {
      const BlackHole3D = window.BlackHole3D
      if (isClearSel) {
        BlackHole3D.BIM.delAllSelElems()
      }

      const terrainType = [10, 13, 21, 22]
      if (dataSets.length === 1) {
        let dataSetInfo = dataSets[0]
        let dataSetId = dataSetInfo.dataSetId
        let locType = BlackHole3D.RECamDirEm.CAM_DIR_DEFAULT
        if (terrainType.includes(dataSetInfo.dataSetType)) {
          if (dataSetInfo.dataSetType !== 10) {
            locType = BlackHole3D.RECamDirEm.CAM_DIR_TOP
          }
        } else {
          locType = BlackHole3D.RECamDirEm.CAM_DIR_TOPRIGHTBACK
        }

        if (dataSetInfo.dataSetType === 10) {
          BlackHole3D.Camera.setCamLocateDefault(locType, true)
        } else {
          BlackHole3D.Camera.setCamLocateToDataSet(dataSetId, 1.0, locType)
        }
      } else {
        let bbox = this.getTotalBBox(dataSets)
        let isIncludesTerrainType = dataSets.some(el =>
          terrainType.includes(el.dataSetType)
        )
        let locType = BlackHole3D.RECamDirEm.CAM_DIR_DEFAULT
        if (isIncludesTerrainType) {
          locType = BlackHole3D.RECamDirEm.CAM_DIR_TOP
        } else {
          locType = BlackHole3D.RECamDirEm.CAM_DIR_TOPRIGHTBACK
        }
        BlackHole3D.Camera.setCamLocateToBound(bbox, 1.0, locType)
      }
    },
    focusEntities(entities, isHighLight) {
      const BlackHole3D = window.BlackHole3D
      let locIDList = []
      entities.forEach(item => {
        let obj = {
          dataSetId: item.dataSetId,
          elemIdList: item.elemIds
        }
        locIDList.push(obj)
      })
      let locType = BlackHole3D.RECamDirEm.CAM_DIR_TOPRIGHTBACK
      BlackHole3D.Camera.setCamLocateToElem(locIDList, 1.0, locType)

      if (isHighLight) {
        BlackHole3D.BIM.delAllSelElems()

        let color = new BlackHole3D.REColor(254, 64, 7, 180)
        entities.forEach(item => {
          BlackHole3D.BIM.addToSelElems(item.dataSetId, item.elemIds)
        })
        BlackHole3D.BIM.setSelElemsAttr(color, 1, true)
      }
    },
    focusElems(dataSets, isFocus, isHighLight) {
      const BlackHole3D = window.BlackHole3D
      BlackHole3D.BIM.delAllSelElems()

      if (isFocus) {
        let locIDList = []
        dataSets.forEach(item => {
          let obj = {
            dataSetId: item.dataSetId,
            elemIdList: item.elemIds
          }
          locIDList.push(obj)
        })
        let locType = BlackHole3D.RECamDirEm.CAM_DIR_TOPRIGHTBACK
        BlackHole3D.Camera.setCamLocateToElem(locIDList, 1.0, locType)
      }

      if (isHighLight) {
        dataSets.forEach(item => {
          BlackHole3D.BIM.addToSelElems(item.dataSetId, item.elemIds)
        })
        let color = new BlackHole3D.REColor(254, 64, 7, 180)
        BlackHole3D.BIM.setSelElemsAttr(color, 1, true)
      }
    },
    showElement(dataSetId, childNodeIds) {
      window.BlackHole3D.BIM.delAllSelElems()
      window.BlackHole3D.BIM.resetElemAttr(dataSetId, childNodeIds)
    },
    hiddenElement(dataSetId, childNodeIds) {
      window.BlackHole3D.BIM.delAllSelElems()
      window.BlackHole3D.BIM.setElemAlpha(dataSetId, childNodeIds, 0)
    },
    hideCadAndVector(dataSetId) {
      const BlackHole3D = window.BlackHole3D
      let unitNames = BlackHole3D.Terrain.getAllUnitNames(dataSetId)
      let unitId = unitNames[0] ? unitNames[0] : ''
      let resType = BlackHole3D.RETerrResEm.ALL
      BlackHole3D.Terrain.setUnitActive(dataSetId, unitId, resType, false)
    },
    showCadAndVector(dataSetId) {
      const BlackHole3D = window.BlackHole3D
      let unitNames = BlackHole3D.Terrain.getAllUnitNames(dataSetId)
      let unitId = unitNames[0] ? unitNames[0] : ''
      let resType = BlackHole3D.RETerrResEm.ALL
      BlackHole3D.Terrain.setUnitActive(dataSetId, unitId, resType, true)
    },
    highLightWaters(waterIds) {
      const Water = window.BlackHole3D.Water
      Water.setCamToData(waterIds)
    },
    highLightExtrudes(extrudeIds) {
      const Extrude = window.BlackHole3D.Extrude
      Extrude.setCamToData(extrudeIds)
    },
    showWaters(waterIds) {
      waterIds.forEach(item => {
        window.BlackHole3D.Water.setVisible(item, true)
      })
    },
    hideWaters(waterIds) {
      waterIds.forEach(item => {
        window.BlackHole3D.Water.setVisible(item, false)
      })
    },
    showExtrudes(extrudeIds) {
      extrudeIds.forEach(item => {
        window.BlackHole3D.Extrude.setVisible(item, true)
      })
    },
    hideExtrudes(extrudeIds) {
      extrudeIds.forEach(item => {
        window.BlackHole3D.Extrude.setVisible(item, false)
      })
    },
    setUnitShpHole(dataSetId, isDigHole) {
      const BlackHole3D = window.BlackHole3D
      let unitNames = BlackHole3D.Terrain.getAllUnitNames(dataSetId)
      let unitId = unitNames[0] ? unitNames[0] : ''
      const resType = BlackHole3D.RETerrResEm.ALL
      const Terrain = BlackHole3D.Terrain
      Terrain.setUnitShpHole(dataSetId, unitId, resType, isDigHole)
    },
    setUnitLayerLevel(dataSetId, level) {
      const BlackHole3D = window.BlackHole3D
      let unitNames = BlackHole3D.Terrain.getAllUnitNames(dataSetId)
      let unitId = unitNames[0] ? unitNames[0] : ''
      let resType = BlackHole3D.RETerrResEm.ALL
      BlackHole3D.Terrain.setUnitLayerlev(dataSetId, unitId, resType, level)
    },
    setUnitLODLevRange(dataSetId, range) {
      const BlackHole3D = window.BlackHole3D
      let unitNames = BlackHole3D.Terrain.getAllUnitNames(dataSetId)
      let unitId = unitNames[0] ? unitNames[0] : ''
      let resType = BlackHole3D.RETerrResEm.ALL
      BlackHole3D.Terrain.setUnitLODLevRange(dataSetId, unitId, resType, range)
    },
    getTotalBBox(dataSets) {
      let xValue = []
      let yValue = []
      let zValue = []

      const BlackHole3D = window.BlackHole3D
      dataSets.forEach(item => {
        let bbox
        if (item.dataSetType === 0) {
          bbox = BlackHole3D.BIM.getTotalBV(item.dataSetId)
        } else {
          bbox = BlackHole3D.Grid.getDataSetBV(item.dataSetId)
        }
        xValue.push(bbox[0], bbox[1])
        yValue.push(bbox[2], bbox[3])
        zValue.push(bbox[4], bbox[5])
      })

      let totalBBox = [
        [Math.min(...xValue), Math.min(...yValue), Math.min(...zValue)],
        [Math.max(...xValue), Math.max(...yValue), Math.max(...zValue)]
      ]

      return totalBBox
    },
    getResourcesAddress(dataSetInfo) {
      let resourcesAddress = ''
      if (window.isMinIO) {
        resourcesAddress = `${dataSetInfo.resourcesAddress}${dataSetInfo.resId}`
      } else {
        resourcesAddress = dataSetInfo.resourcesAddress
      }
      return resourcesAddress
    },
    getDataSetCRS(dataSetInfo) {
      if (dataSetInfo.readonlyCoordinate) return null

      if (!SETCRS_DATA_TYPE.includes(dataSetInfo.dataSetType)) return null

      let crsConfig = dataSetInfo.coordinatesConfig
      if (crsConfig.coordinatesType === 'None') return null

      if (crsConfig.coordinatesType === 'CalibrationPoint') {
        let crsPoint = crsConfig.coordinatesPoint
        let crs = `ENU:${crsPoint.latitude},${crsPoint.longitude}`
        return crs
      } else {
        return crsConfig.coordinates
      }
    },
    getEngineOrigin(dataSetInfo) {
      if (dataSetInfo.readonlyCoordinate) return null

      if (!SETCRS_DATA_TYPE.includes(dataSetInfo.dataSetType)) return null

      let engineOrigin = []
      let crsConfig = dataSetInfo.coordinatesConfig

      let origin = crsConfig.basePoint
      let originArray = []
      if (origin) {
        originArray = origin.split(',').map(Number)
      }

      if (crsConfig.coordinatesType === 'CalibrationPoint') {
        let crsPoint = crsConfig.coordinatesPoint
        let point = crsPoint.coordinates
        let pointArray = []
        if (point) {
          pointArray = point.split(',').map(Number)
        } else {
          pointArray = [0, 0, 0]
        }

        if (originArray.length) {
          originArray.forEach((item, index) => {
            let result = item - pointArray[index]
            engineOrigin.push(result)
          })
        } else {
          engineOrigin = pointArray
        }
      } else {
        engineOrigin = originArray
      }

      if (engineOrigin.length) {
        return engineOrigin
      } else {
        return null
      }
    },
    getDataSetCRSNorth(dataSetInfo) {
      if (dataSetInfo.readonlyCoordinate) return null

      if (!SETCRS_DATA_TYPE.includes(dataSetInfo.dataSetType)) return null
      let crsConfig = dataSetInfo.coordinatesConfig
      if (crsConfig.northAngle) {
        return Number(crsConfig.northAngle)
      } else {
        return null
      }
    },
    getTransInfo(dataSetInfo) {
      let sacle = dataSetInfo.scale.split(' ').map(Number)
      let rotate = dataSetInfo.rotate.split(' ').map(Number)
      let translation = dataSetInfo.translation.split(' ').map(Number)
      let transInfo = [sacle, rotate, translation]
      return transInfo
    },
    addCustomBtn(uiID, stateParList, activeStateId) {
      let btnInfo = new window.BlackHole3D.REUIBtnInfo()
      btnInfo.uiID = uiID
      btnInfo.activeStateId = activeStateId

      let tempStateParList = stateParList.map(item => {
        let statePar = new window.BlackHole3D.REUIBtnStateInfo()
        statePar.hintText = item.hintText
        statePar.texPath = item.texPath
        return statePar
      })

      btnInfo.stateParList = tempStateParList
      window.BlackHole3D.Graphics.createSysPanelBtn(btnInfo)
    },
    copyCanvas() {
      const engineContainer = this.$refs.engineContainer
      const engineCanvas = document.getElementById('engineCanvas')
      engineContainer.append(engineCanvas)

      if (this.isEnginePreLoaded()) {
        this.setCanvasSize()
      }
    },
    isEnginePreLoaded() {
      let isPreLoaded = false
      const engineCanvas = document.getElementById('engineCanvas')
      const classList = engineCanvas.classList
      if (classList.contains('is-loaded')) {
        isPreLoaded = true
      }
      return isPreLoaded
    },
    isEngineCanvasExist() {
      let isExist = false
      const engineCanvas = document.getElementById('engineCanvas')
      if (engineCanvas) {
        isExist = true
      } else {
        isExist = false
      }
      return isExist
    },
    createEngineCanvas() {
      const engingCanvasDom = document.createElement('canvas')
      engingCanvasDom.id = 'engineCanvas'
      engingCanvasDom.classList.add('engine-canvas-box')
      // prettier-ignore
      engingCanvasDom.oncontextmenu = e => { e.preventDefault() }
      engingCanvasDom.tabIndex = '1'

      const engineContainer = document.getElementById('engineContainer')
      engineContainer.append(engingCanvasDom)
    }
  },
  watch: {
    viewModeType(newV) {
      if (newV) {
        this.setSceneViewMode()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.scene-view {
  position: relative;
  width: 100%;
  height: 100%;
  background: var(--eng-loading-bgColor);

  .engine-container {
    height: 100%;
    :deep(.engine-canvas-box) {
      outline: none;
      &:focus {
        outline: none;
      }
    }
  }
}
</style>
